import React from 'react';
import I18n from 'i18n-js';
import {
  BuyItNowPaymentOptionsFields,
} from '../../src/schemas/rql';
import BuyItNowApplePayWrapper from './BuyItNowApplePayWrapper';
import CheckoutPayPalButton from './CheckoutPayPalButton';

type Listing = BuyItNowPaymentOptionsFields.Fragment;

interface Props {
  showPaypalCheckoutButton: boolean;
  adyenCheckoutPaymentMethodsConfig: string;
  onError: (errors) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  listing: Listing;
  quantity?: number;
}

export default function BuyItNowExpressPayWrapper({
  showPaypalCheckoutButton,
  adyenCheckoutPaymentMethodsConfig,
  onError,
  isLoading,
  setIsLoading,
  listing,
  quantity = null,
}: Props) {
  return (
    <div className="d-flex fx-dir-col fx-align-center">
      <fieldset className="bd-1 bd-color-primary mb-2 d-flex fx-dir-col fx-align-center pb-3 pt-2 plr-2">
        <legend className="weight-bold mlr-auto">{I18n.t('discovery.checkout.expressPay.title')}</legend>
        <div className="mb-1">
          {showPaypalCheckoutButton &&
            <CheckoutPayPalButton
              currency={listing.currency}
              checkoutBundlingId={buildCheckoutBundlingIdForListing(listing.id)}
              onError={onError}
              variant="buy-now"
              quantity={quantity}
            />
          }
        </div>
        <BuyItNowApplePayWrapper
          listingId={listing.id}
          listingCurrencyCode={listing.currency}
          paymentMethodsConfig={adyenCheckoutPaymentMethodsConfig}
          setIsLoading={setIsLoading}
          isDisabled={isLoading}
          onError={onError}
          inExpressPay
        />
      </fieldset>
    </div>
  );
}

function buildCheckoutBundlingIdForListing(listingId) {
  return `RL-${listingId}`;
}
